import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export type BillingStatus = "active" | "overdue" | "suspended";

export function useBillingStatus() {
  const { user } = useAuth();
  const q = useQuery<BillingStatus>({
    queryKey: ["billing-status", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_user_tenant_billing_status");
      if (error) throw error;
      return ((data as unknown as string) ?? "active") as BillingStatus;
    },
    enabled: !!user,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
  return {
    status: q.data ?? "active",
    isSuspended: q.data === "suspended",
    isOverdue: q.data === "overdue",
    loading: q.isLoading,
  };
}
